import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { GetSitesGQL, DeleteSiteGQL } from '../graphql/graphql';
import { AuthService } from '../auth/auth.service';

@Component({
    selector: 'app-sites-list',
    templateUrl: './sites-list.component.html',
    styleUrls: ['./sites-list.component.scss'],
    standalone: false
})
export class SitesListComponent implements OnInit {

  sites: any[] = [];
  loading = true;
  showModal = false;
  showDeleteModal = false;
  siteToDelete: string | null = null;
  successMessage: string = '';
  errorMessage: string = '';

  constructor(
    private getSitesGQL: GetSitesGQL,
    private deleteSiteGQL: DeleteSiteGQL,
    public auth: AuthService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.loadSites();
  }

  private loadSites() {
    this.getSitesGQL.fetch({ fetchPolicy: 'network-only' }).subscribe((result) => {
      this.sites = result.data?.sites || [];
      this.loading = false;
    });
  }

  openAddSiteModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  onSiteCreated() {
    this.closeModal();
    this.loadSites();
    this.onSuccess('Site created successfully!');
  }

  onSuccess(message: string) {
    this.successMessage = message;
    this.errorMessage = '';
    setTimeout(() => this.successMessage = '', 3000);
  }

  onError(message: string) {
    this.errorMessage = message;
    this.successMessage = '';
  }

  deleteSite(siteId: string) {
    this.siteToDelete = siteId;
    this.showDeleteModal = true;
  }

  confirmDelete() {
    if (this.siteToDelete) {
      this.deleteSiteGQL.mutate({ variables: { id: this.siteToDelete } }).subscribe({
        next: () => {
          this.loadSites();
          this.showDeleteModal = false;
          this.siteToDelete = null;
          this.onSuccess('Site deleted successfully!');
        },
        error: (error) => {
          console.error('Error deleting site:', error);
          this.showDeleteModal = false;
          this.siteToDelete = null;
          this.onError('Failed to delete site. Please try again.');
        }
      });
    }
  }

  cancelDelete() {
    this.showDeleteModal = false;
    this.siteToDelete = null;
  }
  isSvgMarkup(value: string): boolean {
    return value?.trim().startsWith('<');
  }

  sanitizeSvg(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }



  
}
